import { TargetBuilder } from "./builder/target-builder";
import { SpecError } from "./errors";
import { ExcelReader } from "./reader/excel-reader";
import { SpecParser } from "./parser/spec-parser";
import type { ConversionResult, ConvertOptions } from "./types";
import { WarningCollector } from "./warnings/warning-collector";

/**
 * 仕様書 Excel (`.xlsx`) → `ConvertedTarget[]` 変換のエントリポイント (read → parse → build を順に呼ぶ薄い orchestrator)。
 */
export class SpecToTargetConverter {
  /** @throws {SpecError} `INVALID_FILE_FORMAT` / `MISSING_REQUIRED_SHEET` / `INPUT_TOO_LARGE` / `DUPLICATE_NAME_AT_SAME_LEVEL` */
  async convert(
    input: ArrayBuffer | Uint8Array,
    options?: ConvertOptions,
  ): Promise<ConversionResult> {
    const warnings = new WarningCollector();
    const reader = new ExcelReader();
    const parser = new SpecParser(warnings);
    const builder = new TargetBuilder(warnings);

    try {
      options?.onProgress?.("reading", 0);
      const sheets = reader.read(input);
      options?.onProgress?.("reading", 33);

      options?.onProgress?.("parsing", 33);
      const parsed = parser.parse(sheets);
      options?.onProgress?.("parsing", 66);

      options?.onProgress?.("building", 66);
      const { targets, stats } = builder.build(parsed);
      // 成功時のみ 100% を emit (「100% = 成功完了」のシグナルを保つ)。
      options?.onProgress?.("building", 100);
      return {
        targets,
        warnings: warnings.collect(),
        stats,
      };
    } catch (err) {
      // 致命エラーで途中まで蓄積された警告を SpecError に添付して rethrow。
      if (err instanceof SpecError) {
        err.warnings = warnings.collect();
      }
      throw err;
    }
  }
}
